import { capitalizeEachWord } from "@/helpers/string";
import { AggregationType } from "@/types/widget";
import { formatNumber } from "@/utils/number";
import { removeSpecialCharacters } from "@/utils/string";

type BigDataChartProps = {
  value: number;
  type: AggregationType;
  measure: string;
};

export default function BigDataChart({
  value,
  type,
  measure
}: Readonly<BigDataChartProps>) {
  return (
    <div
      className={`bg-white flex rounded-xl py-2 px-3 gap-3 border border-gainsboro w-full max-w-[400px]`}
    >
      <div
        className={`w-1 self-stretch rounded-full shrink-0 bg-solid-green`}
      />
      <div className="flex flex-col">
        <p className="text-txtBody text-xs font-semibold">
          {removeSpecialCharacters(capitalizeEachWord(`${type} ${measure}`))}
        </p>
        <p className="text-primary-teal text-2xl font-semibold">
          {formatNumber(value, "decimal")}
        </p>
      </div>
    </div>
  );
}
